import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ComputersService, RmmService } from '@services';
import { PagedSelectModule } from '@shared/components/paged-select/paged-select.module';
import { I18NextModule } from 'angular-i18next';
import { ListSelectModule, MbsUiKitModule, TagsInputModule } from 'mbs-ui-kit';
import { NotificationsCheckboxesComponent } from 'mbs-ui-shared@components/notifications-checkboxes/notifications-checkboxes.component';
import { ComputerTagsFacade } from 'mbs-ui-shared@facades/computer.tags.facade';
import { CodeEditorModule } from 'mbs-ui-shared@modules/code-editor/code-editor.module';
import { IterationCtrlButtonModule } from 'mbs-ui-shared@modules/iteration-ctrl-button/iteration-ctrl-button.module';
import { TimeSchedulerModule } from 'mbs-ui-shared@modules/time-scheduler/time-scheduler.module';
import { UtilitySelectionModalModule } from 'mbs-ui-shared@modules/utility-selection-modal/utility-selection-modal.module';
import { CompaniesService } from 'mbs-ui-shared@services/companies.service';
import { RmmCustomAlertingService } from 'mbs-ui-shared@services/rmm-custom-alert.service';
import { RmmNotificationService } from 'mbs-ui-shared@services/rmm-notifications.service';
import { ComputerSmartSearchService } from 'mbs-ui-shared@services/smart-search-template.service';
import { ComputerTagsStoreModule } from 'mbs-ui-shared@store/computerTags';
import { RMMPushNotificationsModule } from '../push-notifications/push-notifications.component.module';
import { RmmCustomBaseAlertingModule } from '../rmm-custom-alerting-module/rmm-custom-base-alerting.module';
import { RmmCustomAlertingServiceController } from '../rmm-custom-alerting-module/services/rmm-custom-alerting-controller.service';
import { RmmSelectServiceModalModule } from '../rmm-select-service-modal/rmm-select-service-modal.module';
import { SnmpCustomNotificationModule } from '../snmp-custom-notifications/snmp-custom-notifications.module';
import { ActionTemplate } from './components/action-template/action-template.component';
import { RmmNotificationsApplyProfileToComponent } from './components/apply-profile-to/apply-profile-to.component';
import { AlertProfileNotificationSettingsAction } from './components/profile-notification-settings/components/alert-profile-notifications/alert-profile-notifications.component';
import { CommonProfileNotificationSettingsAction } from './components/profile-notification-settings/components/common-profile-notifications/common-profile-notification-settings.component';
import { CustomProfileNotificationUtility } from './components/profile-notification-settings/components/custom-profile-notification-utility/custom-profile-notification-utility.component';
import { ProfileNotificationScriptUtility } from './components/profile-notification-settings/components/profile-notification-script-utility/profile-notification-script-utility.component';
import { ProfileNotificationSettingsAction } from './components/profile-notification-settings/profile-notification-settings.component';
import { SelectActionComponent } from './components/select-action/select-action.component';
import { ShowSummaryComponent } from './components/show-summary/show-summary.component';
import { UtilityAlertSummaryComponent } from './components/utility-alert-summary/utility-alert-summary.component';
import { RMMCustomNotificationWizardComponent } from './rmm-custom-notification-wizard.component';
import { AlertNotificationService } from './services/alert-notification.service';
import EditRmmNotificationUtility from './utility/edit-rmm-notification-utility';
import { LoadRmmCustomNotificationWizardService } from './utility/load-rmm-custom-notification-wizard.service';

const declarations = [
  SelectActionComponent,
  ShowSummaryComponent,
  ActionTemplate,
  UtilityAlertSummaryComponent,
  RmmNotificationsApplyProfileToComponent,
  ProfileNotificationSettingsAction,
  CustomProfileNotificationUtility,
  CommonProfileNotificationSettingsAction,
  AlertProfileNotificationSettingsAction,
  ProfileNotificationScriptUtility
];

@NgModule({
  imports: [
    CommonModule,
    MbsUiKitModule,
    NgbTooltipModule,
    FormsModule,
    I18NextModule,
    ReactiveFormsModule,
    TimeSchedulerModule,
    IterationCtrlButtonModule,
    CodeEditorModule,
    ListSelectModule,
    TagsInputModule,
    ComputerTagsStoreModule,
    SnmpCustomNotificationModule,
    PagedSelectModule,
    NotificationsCheckboxesComponent,
    RMMPushNotificationsModule,
    RmmSelectServiceModalModule,
    RmmCustomBaseAlertingModule,
    UtilitySelectionModalModule
  ],
  declarations: [RMMCustomNotificationWizardComponent, ...declarations],

  providers: [
    LoadRmmCustomNotificationWizardService,
    RmmCustomAlertingServiceController,
    ComputerSmartSearchService,
    RmmCustomAlertingService,
    CompaniesService,
    ComputerTagsFacade,
    ComputersService,
    EditRmmNotificationUtility,
    RmmService,
    AlertNotificationService,
    RmmNotificationService
  ],
  exports: [RMMCustomNotificationWizardComponent]
})
export class RMMCustomNotificationWizardModule {}
